let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j1MU5")).then(() => parcelRequire('fPGDa'));